/*
 * Public API Surface of spinners-angular
 */

export * from './lib/spinners-angular.module';
